import * as React from 'react';
import { EmptyState } from '@/components/admin/empty-state';
import { Button } from '@/components/ui/button';

type PageErrorBoundaryProps = {
  pageName: string;
  onReportProblem: () => void;
  children: React.ReactNode;
};

/** Key this boundary by route so navigating away clears a failed page. */
export class PageErrorBoundary extends React.Component<PageErrorBoundaryProps, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`Page failed to render: ${this.props.pageName}`, error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <EmptyState
        title="This page failed to render"
        description="Reload the page or report the problem."
        action={(
          <div className="flex flex-wrap justify-center gap-2">
            <Button onClick={() => window.location.reload()}>Reload page</Button>
            <Button variant="outline" onClick={this.props.onReportProblem}>Report a problem</Button>
          </div>
        )}
      />
    );
  }
}
